import { Button, HStack, Text } from "@chakra-ui/react";
import { UserFragment } from "gql/graphql";
import { useFlags } from "launchdarkly-react-client-sdk";
import React, { memo, useCallback } from "react";
import colors from "app/colors";

interface IProps {
  user: UserFragment;
}

const UserInvite: React.FC<IProps> = ({ user }) => {
  const { userProvisioning: userProvisioningFF } = useFlags();

  const onInviteClicked = useCallback(() => {
    const subject = "Download Synco now and stay in the loop with your team";
    const body = `Hi${user.firstName ? ` ${user.firstName}` : ""}, you're now set up with a Synco account. Download the app here https://app.teamsynco.com/mobile and sign in so you're connected with the team.`;
    const mailtoLink = `mailto:${user.email ? encodeURIComponent(user.email) : ""}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  }, [user.email, user.firstName]);

  if (!userProvisioningFF || !user.email) {
    return null;
  }

  return (
    <HStack bg={colors.blueLight} alignItems="start" borderRadius="4px" mt={1}>
      <Text color={colors.blue} fontSize={14} fontWeight={600}>
        Invite them to download the app
      </Text>
      <Button
        variant="hover"
        size="xs"
        bg={colors.blue}
        fontSize={12}
        fontWeight={700}
        color={colors.white}
        onClick={onInviteClicked}
      >
        Invite
      </Button>
    </HStack>
  );
};

export default memo(UserInvite);
